<template>
    <flex-container>
        <breadcrumbs-skeleton>
            <simple-breadcrumbs :contact-id="props.contactId" />
        </breadcrumbs-skeleton>

        <leads-and-orders-card-tabs-skeleton>
            <leads-and-orders-card-tabs :contact-id="props.contactId" />
        </leads-and-orders-card-tabs-skeleton>

        <flex-container :size="6">
            <tasks-and-appointments-card-tabs-skeleton>
                <tasks-and-appointments-card-tabs :contact-id="props.contactId" />
            </tasks-and-appointments-card-tabs-skeleton>

            <woon-objecten-card-skeleton>
                <woon-objecten-card :contact-id="localContactId" />
            </woon-objecten-card-skeleton>

            <comments-card-skeleton>
                <comments-card
                    :filters="{
                        company: client.session.companyId?.toString(),
                        'lead.primaryContact': props.contactId,
                    }"
                />
            </comments-card-skeleton>
        </flex-container>

        <flex-container :size="4">
            <contact-card-skeleton>
                <contact-card :contact-id="props.contactId" />
            </contact-card-skeleton>

            <smart-marketing-card-skeleton>
                <!-- TODO: Needs a refactor to reusable location and more aligned naming for the subcomponents -->
                <smart-marketing-card :contact-id="props.contactId" />
            </smart-marketing-card-skeleton>
        </flex-container>
    </flex-container>

    <suspense>
        <router-view />
    </suspense>
</template>

<script setup lang="ts">
    import {
        FlexContainer,
    } from '@keyvue/one-ui';

    import CommentsCard from '@components/Cards/CommentsCard.vue';
    import SmartMarketingCard from '@views/Contact/Detail/Cards/SmartMarketingCard.vue';

    import useClient from '@/composables/useClient';
    import ContactCard from '@components/Cards/ContactCard.vue';
    import LeadsAndOrdersCardTabs from '@components/Cards/LeadsAndOrdersCardTabs.vue';
    import LeadsAndOrdersCardTabsSkeleton from '@components/Skeleton/Cards/LeadsAndOrdersCardTabsSkeleton.vue';
    import TasksAndAppointmentsCardTabsSkeleton from '@components/Skeleton/Cards/TasksAndAppointmentsCardTabsSkeleton.vue';
    import TasksAndAppointmentsCardTabs from '@components/Cards/TasksAndAppointmentsCardTabs.vue';
    import CommentsCardSkeleton from '@components/Skeleton/Cards/CommentsCardSkeleton.vue';
    import ContactCardSkeleton from '@components/Skeleton/Cards/ContactCardSkeleton.vue';
    import SmartMarketingCardSkeleton from '@components/Skeleton/Cards/SmartMarketingCardSkeleton.vue';
    import BreadcrumbsSkeleton from '@components/Skeleton/BreadcrumbsSkeleton.vue';
    import SimpleBreadcrumbs from '@views/Contact/Detail/SimpleBreadcrumbs.vue';
    import WoonObjectenCard from '@/realworks/components/card/WoonObjectenCard.vue';
    import WoonObjectenCardSkeleton from '@/realworks/components/skeleton/WoonObjectenCardSkeleton.vue';
    import { ContactId } from '@keyvue/one-api-client';
    import { provideContactPageData } from '@composables/useContactPageData';

    interface Props {
        contactId: string;
    }

    const props = defineProps<Props>();

    const { client } = useClient();

    provideContactPageData(props.contactId);

    const localContactId = new ContactId(props.contactId);
</script>

<style scoped lang="scss">
.card-tab-label-custom {
    min-width: max-content;
    padding: size(sm) size(sm) 0 size(sm) !important;
}
</style>
